const getSeriesFromData = (data, hiddenColumns) => {
    // if there is not a 'Value' column, then the series
    // values are stored in a column for each series name
    const seriesAreDistinctColumns =
        typeof Object.keys(data[0]).find((x) => x.includes('Value')) ===
        'undefined'

    if (seriesAreDistinctColumns) {
        // get the line chart series names, eg in { Date: <date>, Series A: <value>, Series B: <district>}
        // => groupKeys == ['Series A', 'Series B']

        // filter out Date and any hiddenColumns
        const groupKeys = data.reduce(
            (acc, curr) => [
                ...acc,
                ...Object.keys(curr)
                    .filter((x) => !x.includes('Date'))
                    .filter((x) => !hiddenColumns.includes(x)),
            ],
            []
        )

        // get a list of all unique groups that are present in the data
        // => ['Series A', 'Series B']
        const uniqueGroups = [...new Set([...groupKeys])].sort()

        // return data + group names
        return [data, uniqueGroups, null]
    } else {
        // otherwise, the group key is just the column that is not Value or Date
        // eg data[0] = {'Value': 0, 'Date': '12/12/12', 'Form Type': 'Wow'}
        // => groupKey = 'Form Type'
        const groupKey = Object.keys(data[0]).find(
            (x) =>
                !(x.includes('Date') || x.includes('Value')) &&
                !hiddenColumns.includes(x)
        )

        // get the set of all unique values in the column specified by groupKey
        const uniqueGroups = [...new Set(data.map((x) => x[groupKey]))].sort()

        // aggregate line chart data using unique dates. eg
        // [{Date: date1, District: 1, Value: 100}, {Date: date1, District: 2, Value: 200}]
        // turns into [{Date: date1, "1": 100, "2": 200}]
        const chartData = [...new Set(data.map((d) => d.Date))]
            .sort()
            .map((date) => {
                const dateEntry = { Date: date }
                return data
                    .filter((x) => x.Date === date) // get entries associated w/ the current date
                    .reduce((acc, curr) => {
                        const groupName = curr[groupKey]
                        const value = curr['Value']
                        return {
                            ...acc,
                            [groupName]: value,
                        }
                    }, dateEntry)
            })
            .sort((a, b) => a.Date - b.Date)

        return [chartData, uniqueGroups, groupKey]
    }
}

const getReferenceLineData = (options) => {
    if (options) {
        try {
            const config = JSON.parse(options)
            const referenceData = config.reference ? config.reference : null
            return referenceData
        } catch (e) {}
    }
}

const getMultiSeriesData = (data, uniqueGroups, groupKey, xKey, yKey) => {
    const d = uniqueGroups.map((group) => {
        const relatedRecords = data
            .filter((f) => f[groupKey] === group)
            .map((k) => ({ x: k[xKey], y: k[yKey], ...k }))
            .sort((a, b) => a[yKey] - b[yKey])
        return {
            name: group,
            data: [...relatedRecords],
        }
    })  
    return d
}

export { getSeriesFromData, getReferenceLineData, getMultiSeriesData }
